






























































































































import { Component, Prop, Vue, Emit,Watch } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';

@Component
export default class UsageDialog extends Vue {
  @Prop({default:false}) public showRoadmap:boolean; 
  @Prop({default:null}) public roadmapMessage:string;
  currentMonth:boolean = true;
  showDialog: boolean = false;
  usageQueryResult : Common.UsageQueryResult;
  roadmapFlags = Common.RoadmapFlags;

  get title():string{
    if (this.showRoadmap) return this.usageQueryResult.isPreparationCompleted? "ロードマップ" : "事前準備";
    else return "利用状況照会"
  }
  usageCountersMaster :Common.UsageCounter[] = [];
  usageCountersSales :Common.UsageCounter[] = [];
  usageCountersPurchase :Common.UsageCounter[] = [];
  
  get hasNextStep():boolean {
    if (this.showRoadmap && this.usageQueryResult.steps  && this.usageQueryResult.steps.length > 0) return true;
    else return false;
  }
  onOk(){
    this.showDialog = false;
    if (this.hasNextStep){
      var step = this.usageQueryResult.steps[0];
      this.onLinkClick(step.url);
    }
  }
  created(){

    var countType = Common.UsageCountType.Default;
    if (this.$api.license.isTrial == false) countType = this.currentMonth ? Common.UsageCountType.CurrentMonth : Common.UsageCountType.PreviousMonth;

    this.$api.execute(new Common.UsageQuery(countType))
    .then(obj => {
        this.usageQueryResult = obj;
        this.setCounters();
        if(this.$api.license.isTrial) this.$api.setRoadmapRatio(this.usageQueryResult);
        if(this.showRoadmap) this.$api.clearRoadmapAlert();
        this.showDialog = true;
      })
  }
  onLinkClick(path : string){
     this.showDialog = false;
    this.$router.push(path);
  }

  setCounters(){
    this.usageCountersMaster = this.usageQueryResult.counters.filter(obj =>obj.roadmapFlag == Common.RoadmapFlags.Default || obj.roadmapFlag >= Common.RoadmapFlags.Commodity);
    this.usageCountersSales = this.usageQueryResult.counters.filter(obj =>obj.roadmapFlag >= Common.RoadmapFlags.SalesOrder && obj.roadmapFlag <= Common.RoadmapFlags.SalesPayment);
    this.usageCountersPurchase= this.usageQueryResult.counters.filter(obj =>obj.roadmapFlag >= Common.RoadmapFlags.PurchaseOrder && obj.roadmapFlag <= Common.RoadmapFlags.PurchasePayment);
  }
  @Watch('currentMonth')
  public reload(){
    this.$api.execute(new Common.UsageQuery(this.currentMonth ? Common.UsageCountType.CurrentMonth : Common.UsageCountType.PreviousMonth))
    .then(obj => {
        this.usageQueryResult = obj;
        this.setCounters();
        if(this.$api.license.isTrial) this.$api.setRoadmapRatio(this.usageQueryResult);
        this.$forceUpdate();
      })
  }
}
